import React from 'react'

export default function Error() {
    return(
        <>
            <p>Something went wrong. <a href="/">Reload</a></p>
        </>
    )
}